import type { IconName, InputProps } from '@economic/taco';
import type { Country } from '../../type';

export interface CompanyInformation {
    companyName: string;
    country: string;
    cvr: string;
    agreeWithTerms: boolean;
}

export interface PaymentCardsOnboardingDialogCompanyData {
    companyName: string;
    country: string;
    cvr: string;
}

export interface PaymentCardsOnboardingDialogState {
    agreementNumber: number;
    formData: CompanyInformation;
    companyData: PaymentCardsOnboardingDialogCompanyData;
    countries: Country[];
    isLoading: boolean;

    step: OnboardingStepEnum;
    walletUrl: string;
}

export enum OnboardingStepEnum {
    STEP1 = 'service_cost',
    STEP2 = 'company_information',
    STEP3 = 'to_mynt',
}

export interface StepConfigStepAction {
    icon?: IconName;
    text: string;
    stateOnClick: (
        state: PaymentCardsOnboardingDialogState
    ) => Promise<
        (Partial<PaymentCardsOnboardingDialogState> & { error?: string; success?: string; redirectUrl?: string }) | null
    >;
    isDisabled?: (state: PaymentCardsOnboardingDialogState) => boolean;
}

export interface StepConfig {
    prev: StepConfigStepAction;
    next: StepConfigStepAction;
    index: number;
    Component: () => JSX.Element;
}

export type StepConfigs = Record<OnboardingStepEnum, StepConfig>;

export interface IPaymentCardsOnboardingDialogContext {
    state: PaymentCardsOnboardingDialogState;
    config: StepConfigs;
    currentConfig: StepConfig;

    // data handling
    updateCompanyInfo: (value: unknown, name: keyof CompanyInformation) => void;
    openMasterSettings: () => void;

    // dialog navigation
    onContinue: () => void;
    onBack: () => void;

    onCloseDialog: () => void;
}

export interface CompanyInputProps<T>
    extends Partial<Pick<InputProps, 'type' | 'placeholder' | 'readOnly' | 'disabled' | 'required'>> {
    name: keyof CompanyInformation;
    error?: string;
    label?: string;
    value?: T;
    onChange?: IPaymentCardsOnboardingDialogContext['updateCompanyInfo'];
}
